import { useInfiniteQuery } from '@tanstack/react-query';

import type { Car } from '@/api/cars/types';
import { client } from '@/api/common';

type Variables = {
  text?: string;
};

type NeedsSetupCarsPage = {
  data: Car[];
  meta: {
    page: number;
    totalPages: number;
    totalCount: number;
  };
};

const fetchNeedsSetupCars = async ({
  pageParam,
  variables,
}: {
  pageParam: number;
  variables: Variables;
}) => {
  try {
    let params: Record<string, any> = {
      page: pageParam,
    };

    if (variables.text) {
      params.text = variables.text;
    }

    const response = await client.get('v2/internal/partners/cars/needs-setup', {
      params: { ...params },
    });

    return response.data;
  } catch (error) {
    console.error('fetchNeedsSetupCars error:', error);
    throw error;
  }
};

export const useNeedsSetupCarsPaginated = (variables: Variables) => {
  return useInfiniteQuery({
    queryKey: ['internal/partners/cars/needs-setup-paginated', variables],
    queryFn: ({ pageParam = 1 }) =>
      fetchNeedsSetupCars({
        pageParam,
        variables,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage: NeedsSetupCarsPage) => {
      if (lastPage.meta.page >= lastPage.meta.totalPages) {
        return undefined;
      }
      return lastPage.meta.page + 1;
    },
  });
};
